import Yup from 'utils/validation/yup-extensions';
import Box from '@mui/material/Box';
import AppWrappedSelect from 'pages/ApplicationRequest/components/containers/AppWrappedSelect';

const ANESTHESIOLOGY_VENDOR_OPTIONS = [
	{ key: '112005', value: 'PeriopAnesConsultants' },
	{ key: '1120001', value: 'BlueMtn' },
	{ key: '1120002', value: 'CommAnesAssoc' },
	{ key: '1120003', value: 'Premier' },
	{ key: '1120004', value: 'Perfusion' },
	{ key: '1120010', value: 'Employed' },
	{ key: '1120011', value: 'Contracted' },
	{ key: '1071233333', value: 'NAPA' },
];

export const FORM_FIELD_KEYS = {
	ANESTHESIOLOGY_VENDOR: 'ANESTHESIOLOGY_VENDOR',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR]: '',
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR]: Yup.string().required(
		'Please select a vendor.',
	),
};

/**
 * Anesthesiology vendor supplement form fields.
 * @param {{ formik: import('formik').FormikProps<object> }} props
 */
export const AnesthesiologySupplement = ({ formik }) => {
	return (
		<Box>
			<AppWrappedSelect
				name={FORM_FIELD_KEYS.ANESTHESIOLOGY_VENDOR}
				label='Anesthesiology Vendor'
				formik={formik}
				options={ANESTHESIOLOGY_VENDOR_OPTIONS}
				isRequired
			/>
		</Box>
	);
};
